import { DownloadOutlined } from '@ant-design/icons';
import { message, Modal, Spin } from 'antd';
import React from 'react';
import PdfPreview from './PdfPreview';
import httpClient from '@/httpclient';
import { defaultApiErrorHandler } from '@/helpers/string';
import { useTranslation } from 'react-i18next';
import { getFileName } from '@/services/fileService';
import fileSaver from 'file-saver';

type Props = {
  fileId: string;
  fileName: string;
  onClose: () => void;
};

export default function PdfPreviewModal({ fileId, onClose, fileName }: Props) {
  const { t } = useTranslation();
  const [loading, setIsLoading] = React.useState(false);
  const [fileUrl, setFileUrl] = React.useState<string>();

  React.useEffect(() => {
    if (window.innerWidth < 1200) {
      const loader = message.loading('ダウンロード', 10000000);
      onClose();
      httpClient
        .get(`/tours/download-attachment/${fileId}`, {
          responseType: 'blob',
        })
        .then(res => {
          const url = window.URL.createObjectURL(res.data);
          downloadFile(url, getFileName(res.headers));
        })
        .catch(err => {
          defaultApiErrorHandler(err);
        })
        .finally(() => {
          if (loader) {
            loader();
          }
        });
    } else {
      setIsLoading(true);
      setFileUrl(undefined);
      httpClient
        .get(`/tours/download-attachment/${fileId}`, {
          responseType: 'blob',
        })
        .then(res => {
          const url = window.URL.createObjectURL(res.data);
          setFileUrl(url);
        })
        .catch(err => {
          defaultApiErrorHandler(err);
          onClose();
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [fileId]);

  const downloadFile = (fileUrl: string, fileName: string) => {
    if (fileUrl) {
      fileSaver.saveAs(fileUrl, fileName);
    }
  };
  return window.innerWidth >= 1200 ? (
    <Modal
      className="nta-custom-form create-tour-form tour-info-modal"
      visible={true}
      bodyStyle={{
        height: 'calc(100vh - 130px)',
        overflow: 'auto',
        minHeight: 600,
      }}
      onCancel={onClose}
      style={{ top: 0, width: '100%', height: '100%' }}
      width={'100%'}
      title={fileName}
      okButtonProps={{ icon: <DownloadOutlined />, className: 'save-btn', loading }}
      cancelButtonProps={{ style: { float: 'left' } }}
      cancelText={t('Close')}
      onOk={() => downloadFile(fileUrl || '', fileName)}
      okText={'ダウンロード'}
      maskClosable={false}
    >
      <Spin spinning={loading}>
        <div style={{ display: 'flex', minHeight: 600 }}>
          <div style={{ margin: '0 auto' }}>{fileUrl ? <PdfPreview width={1190} url={fileUrl} /> : null}</div>
        </div>
      </Spin>
    </Modal>
  ) : null;
}
